/* ll-static-header.js — merged bundle
   Combines three previously separate, separately-requested header modules:
     1. ll-static-header-551f90.js  header state, cart badge, nav themes, mobile nav sync
     2. ll-static-header-f09810.js  disables sticky header on phones
     3. ll-static-header-e35727.js  desktop nav flyout sizing and placement
   Merged to cut 3 render-blocking requests to 1 deferred request.
   Load order is preserved exactly as it was in static-header.liquid. */

/* ===== 1/3 header state, cart, nav themes (was ll-static-header-551f90.js) ===== */

  (function () {
    var header = document.querySelector('[data-site-header]');
    if (!header || header.dataset.tcgHeaderReady === 'true') return;
    header.dataset.tcgHeaderReady = 'true';

    function hideSearchCategories() {
      header.querySelectorAll('.live-search .live-search-filter-wrapper').forEach(function (wrapper) {
        wrapper.hidden = true;
        wrapper.setAttribute('aria-hidden', 'true');
        wrapper.style.setProperty('display', 'none', 'important');
      });
    }

    hideSearchCategories();
    var liveSearch = header.querySelector('.live-search');
    if (liveSearch) {
      new MutationObserver(hideSearchCategories).observe(liveSearch, { childList: true, subtree: true });
    }

    var accountTemplate = header.querySelector('[data-tcg-mobile-account]');
    var mobileNavRoot = header.querySelector('.site-mobile-nav');
    if (accountTemplate && mobileNavRoot && !mobileNavRoot.querySelector('.tcg-mobile-account')) {
      /* Insert into the menu LIST only — never into the My Account/Logout header toolbar row */
      var mobileMenu =
        mobileNavRoot.querySelector('.site-mobile-nav__content .navmenu') ||
        mobileNavRoot.querySelector('.site-mobile-nav__drawer .navmenu') ||
        mobileNavRoot.querySelector('.site-mobile-nav__panel .navmenu') ||
        mobileNavRoot.querySelector('.navmenu') ||
        mobileNavRoot.querySelector('ul.navmenu') ||
        mobileNavRoot.querySelector('.site-mobile-nav__content > ul') ||
        mobileNavRoot.querySelector('.site-mobile-nav__drawer > ul');

      var accountNode = accountTemplate.content.cloneNode(true);
      var accountEl = accountNode.querySelector ? accountNode.querySelector('.tcg-mobile-account') : null;
      if (!accountEl && accountNode.classList && accountNode.classList.contains('tcg-mobile-account')) {
        accountEl = accountNode;
      }
      /* The drawer now carries a dedicated mount at the top of the panel, so
         the account is a pinned header rather than the first item of the menu
         list. It used to be inserted into .navmenu, which put a bordered
         account card between the policy links and the first game section and
         left it competing with the LOGIN icon in the toolbar directly above.

         The old .navmenu path is kept underneath as a fallback: a cached copy
         of site-mobile-nav.liquid without the mount would otherwise drop the
         account out of the drawer entirely. */
      var accountMount = mobileNavRoot.querySelector('[data-tcg-account-mount]');

      if (accountMount) {
        accountMount.appendChild(accountNode);
      } else if (mobileMenu) {
        /* The template is a div, so it needs an li around it to be legal
           inside the menu list. */
        var li = document.createElement('li');
        li.className = 'navmenu-item tcg-mobile-account-wrap';
        li.appendChild(accountNode);
        mobileMenu.insertBefore(li, mobileMenu.firstChild);
      } else {
        /* Fallback: place as a block between toolbar and first nav list */
        var content =
          mobileNavRoot.querySelector('.site-mobile-nav__content, .site-mobile-nav__drawer, .site-mobile-nav__panel') ||
          mobileNavRoot;
        var firstList = content.querySelector('ul, .navmenu');
        var wrap = document.createElement('div');
        wrap.className = 'tcg-mobile-account';
        if (accountEl) {
          while (accountEl.firstChild) wrap.appendChild(accountEl.firstChild);
        } else {
          wrap.appendChild(accountNode);
        }
        if (firstList && firstList.parentNode) firstList.parentNode.insertBefore(wrap, firstList);
        else content.insertBefore(wrap, content.firstChild);
      }
    }

    /* With mobile_layout set to "below", Empire appends the policy links to the
       end of the drawer content, which lands them after the social row that is
       already sitting there. Legal text belongs under the social icons, not
       over them, so the social row is moved back down once Empire has placed
       the policy block.

       Moved in the DOM rather than reordered with flex, so that tab order still
       matches what is on screen. Empire's own _loadMobileNavItems bails out
       early if its nodes are already in the document, so it will not undo this
       on a later pass. */
    if (mobileNavRoot) {
      var navContent = mobileNavRoot.querySelector('[data-mobile-nav-content]');
      var socialRow = navContent && navContent.querySelector('[data-utility-mobile]');

      if (navContent && socialRow) {
        var placeSocialLast = function () {
          var policyBlock = navContent.querySelector('.utility-bar__mobile-nav');
          if (!policyBlock) return false;
          if (socialRow !== navContent.lastElementChild) navContent.appendChild(socialRow);
          return true;
        };

        if (!placeSocialLast()) {
          var socialObserver = new MutationObserver(function () {
            if (placeSocialLast()) socialObserver.disconnect();
          });
          socialObserver.observe(navContent, { childList: true });
        }
      }
    }

    function navThemeForLabel(label) {
      var normalized = String(label || '');
      if (normalized.normalize) normalized = normalized.normalize('NFD');
      normalized = normalized.replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim().toLowerCase();

      if (/\b(one piece)\b/.test(normalized)) return 'one-piece';
      if (/\b(disney|lorcana)\b/.test(normalized)) return 'disney';
      if (/\b(digimon)\b/.test(normalized)) return 'digimon';
      if (/\b(pokemon|japanese|scarlet|violet)\b/.test(normalized)) return 'pokemon';
      if (/\b(magic(?: the gathering)?|mtg|lord of the rings|assassin'?s creed)\b/.test(normalized) || /avatar.*last airbender/.test(normalized)) return 'magic';

      return null;
    }

    function applyNavThemes() {
      header.querySelectorAll('.site-navigation, .site-mobile-nav').forEach(function (navRoot) {
        navRoot.querySelectorAll('.navmenu-item').forEach(function (item) {
          var parentItem = item.parentElement && item.parentElement.closest('.navmenu-item[data-tcg-nav-theme]');
          var ownControl = item.querySelector('.navmenu-link, [class*="navmenu-link"], a, button');
          var ownTheme = navThemeForLabel(ownControl && ownControl.textContent);
          var inheritedTheme = parentItem && parentItem.getAttribute('data-tcg-nav-theme');
          item.setAttribute('data-tcg-nav-theme', ownTheme || inheritedTheme || 'default');
        });
      });
    }

    applyNavThemes();
    var themeMobileNav = header.querySelector('.site-mobile-nav');
    if (themeMobileNav) {
      var navThemeFrame = 0;
      new MutationObserver(function () {
        if (navThemeFrame) return;
        navThemeFrame = requestAnimationFrame(function () {
          navThemeFrame = 0;
          applyNavThemes();
        });
      }).observe(themeMobileNav, { childList: true, subtree: true });
    }

    var cart = header.querySelector('.site-header-cart');
    var cartCount = cart && cart.querySelector('[data-header-cart-count]');

    function syncCartVisibility() {
      if (!cart || !cartCount) return;
      var rawCount = cartCount.getAttribute('data-header-cart-count') || cartCount.textContent || '';
      var itemCount = parseInt(String(rawCount).replace(/[^0-9]/g, ''), 10) || 0;
      var hasItems = itemCount > 0;
      cart.setAttribute('data-cart-has-items', hasItems ? 'true' : 'false');
    }

    syncCartVisibility();
    if (cartCount) {
      new MutationObserver(syncCartVisibility).observe(cartCount, {
        attributes: true,
        attributeFilter: ['class', 'data-header-cart-count'],
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    /* ==================================================================
       LIVE CART SYNC
       Every section adds to the basket over AJAX and updates its own count
       selectors - [data-cart-count], .cart-count, #CartCount and so on -
       none of which is this header's [data-header-cart-count]. So the badge
       stayed hidden until the next full page load.

       The header now watches for cart WRITES directly: any request to
       /cart/add|change|update|clear, plus the ll:cart:updated event the
       sections already dispatch. That covers all nine sections, the theme
       and any app, without any of them needing to know the header exists.
       Empty basket still means hidden - only the reveal is now live.
    ================================================================== */
    var cartBusy = false;
    var cartQueued = false;
    var cartLastCount = null;

    function cartRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function paintCart(count) {
      if (!cart || !cartCount) return;
      var n = parseInt(count, 10);
      if (isNaN(n) || n < 0) n = 0;

      /* ATTRIBUTE ONLY - do not also write textContent.
         Liquid renders this span EMPTY and carries the number in
         data-header-cart-count, because the theme's stylesheet prints it with
         content: attr(data-header-cart-count). Setting the text as well put a
         second number in the same badge: two counts stacked in one grid. */
      cartCount.setAttribute('data-header-cart-count', n > 0 ? String(n) : '');
      if (n > 0) cartCount.classList.add('visible');
      else cartCount.classList.remove('visible');
      cart.setAttribute('data-cart-has-items', n > 0 ? 'true' : 'false');

      /* Pop only when the basket actually grew, never on first paint or on
         removal - otherwise the header twitches on every page load. */
      if (cartLastCount !== null && n > cartLastCount) {
        cart.classList.remove('is-bumped');
        void cart.offsetWidth;            /* restart the animation */
        cart.classList.add('is-bumped');
        setTimeout(function () { cart.classList.remove('is-bumped'); }, 600);
      }
      cartLastCount = n;
    }

    function refreshCart() {
      if (!cart || !cartCount) return;
      if (cartBusy) { cartQueued = true; return; }
      cartBusy = true;
      fetch(cartRoot() + 'cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c) paintCart(c.item_count); })
        .catch(function () {})
        .then(function () {
          cartBusy = false;
          if (cartQueued) { cartQueued = false; refreshCart(); }
        });
    }

    if (cart && cartCount && !window.__llHeaderCartSync) {
      window.__llHeaderCartSync = true;

      /* Seed from what Liquid rendered so the first pop is suppressed. */
      var seed = cartCount.getAttribute('data-header-cart-count') || cartCount.textContent || '0';
      cartLastCount = parseInt(String(seed).replace(/[^0-9]/g, ''), 10) || 0;

      var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
      var ping = function () { setTimeout(refreshCart, 120); };

      /* Cart writes are read off the Resource Timing stream rather than by
         wrapping fetch and XMLHttpRequest.

         The wrappers worked, but they put this file frame into the call stack
         of every network call on the page - 65 of them on the home page - and
         Lighthouse charges a stack to whichever script owns the function on
         it. This file is 11.5KB and its own work measures ~2ms, yet PSI
         attributed 994ms of scripting to it, plus a third-party Attribution
         Reporting deprecation, both through the fetch wrapper. It also taxed
         every fetch on the page, and left us buried mid-chain behind whichever
         app wrapped fetch after us (window.fetch.__llHeaderWrapped was already
         false in production).

         PerformanceObserver sees the same requests - fetch and XHR alike, from
         any section, the theme or any app - without intercepting one of them.
         buffered:true picks up a write that landed before this ran. Note that
         refreshCart hits /cart.js, which CART_WRITE does not match, so this
         cannot feed itself. */
      try {
        new PerformanceObserver(function (list) {
          var entries = list.getEntries();
          for (var i = 0; i < entries.length; i++) {
            if (CART_WRITE.test(entries[i].name)) { ping(); return; }
          }
        }).observe({ type: 'resource', buffered: true });
      } catch (e) {
        /* Without PerformanceObserver the section events below still cover
           every Lockett Labs section, which is where baskets are built. */
      }

      /* Events the sections already fire. When the payload carries the cart
         we can paint straight away and skip a round trip. */
      ['ll:cart:updated', 'cart:updated', 'cart:refresh', 'cart:build'].forEach(function (evt) {
        document.addEventListener(evt, function (e) {
          var d = e && e.detail;
          if (d && typeof d.item_count === 'number') paintCart(d.item_count);
          else refreshCart();
        });
      });

      /* Coming back via the back button serves a cached page with a stale
         badge, so re-check on restore and whenever the tab is refocused. */
      window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) refreshCart();
      });

      /* And once on boot, in case something was added on the previous page. */
      refreshCart();
    }

    /* The "/" chip in the field is a promise, so honour it: "/" or Cmd/Ctrl+K
       focuses search. Ignored while typing somewhere else, so it never
       hijacks a real keystroke. */
    (function () {
      var field = header.querySelector(".live-search input:not([type='submit']):not([type='button'])");
      if (!field) return;
      document.addEventListener('keydown', function (e) {
        var slash = e.key === '/' && !e.metaKey && !e.ctrlKey && !e.altKey;
        var cmdK = (e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey);
        if (!slash && !cmdK) return;

        var t = e.target;
        var tag = t && t.tagName ? t.tagName.toUpperCase() : '';
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' ||
            (t && t.isContentEditable)) return;

        e.preventDefault();
        try { field.focus({ preventScroll: false }); } catch (err) { field.focus(); }
        try { field.select(); } catch (err2) {}
      });
    })();

    /* ==================================================================
       TYPING PLACEHOLDER
       The field cycles real product titles so the search suggests what it
       can actually find, rather than sitting on one generic prompt.

       Rules it has to respect:
         · never while the field is focused or has a value - it must never
           look like text the shopper typed
         · the ORIGINAL placeholder is restored on focus and on teardown
         · nothing runs while the tab is hidden, or under reduced motion
    ================================================================== */
    (function () {
      var form = header.querySelector('.live-search form');
      var field = header.querySelector(".live-search input:not([type='submit']):not([type='button'])");
      if (!form || !field) return;

      var raw = document.getElementById('tcg-search-hints');
      var hints = [];
      try { hints = JSON.parse(raw ? raw.textContent : '[]') || []; } catch (e) { hints = []; }
      hints = hints.filter(function (h) { return h && h.length > 2; });
      if (!hints.length) return;

      var base = field.getAttribute('placeholder') || '';
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return;

      /* Shuffle so every visit does not open on the same product. */
      for (var i = hints.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = hints[i]; hints[i] = hints[j]; hints[j] = t;
      }

      var TYPE = 55, ERASE = 26, HOLD = 1700, GAP = 420;
      var idx = 0, ch = 0, erasing = false, timer = null, stopped = false;

      function idle() {
        return document.activeElement !== field && !field.value && !document.hidden;
      }

      function step() {
        if (stopped) return;
        if (!idle()) { schedule(500); return; }

        var word = hints[idx % hints.length];
        if (!erasing) {
          ch++;
          field.setAttribute('placeholder', word.slice(0, ch));
          if (ch >= word.length) { erasing = true; schedule(HOLD); return; }
          schedule(TYPE);
        } else {
          ch--;
          field.setAttribute('placeholder', ch > 0 ? word.slice(0, ch) : base);
          if (ch <= 0) { erasing = false; idx++; schedule(GAP); return; }
          schedule(ERASE);
        }
      }

      function schedule(ms) {
        clearTimeout(timer);
        timer = setTimeout(step, ms);
      }

      function restore() {
        clearTimeout(timer);
        ch = 0; erasing = false;
        field.setAttribute('placeholder', base);
      }

      /* Focus hands the field back immediately - the shopper should never be
         typing over a moving target. */
      field.addEventListener('focus', function () { restore(); });
      field.addEventListener('blur', function () { if (!field.value) schedule(900); });
      field.addEventListener('input', function () { if (field.value) restore(); });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) clearTimeout(timer);
        else if (idle()) schedule(700);
      });

      document.addEventListener('shopify:section:unload', function () {
        stopped = true; restore();
      });

      schedule(1400);   /* let the page settle before anything moves */
    })();

    var mobileNav = header.querySelector('.site-mobile-nav');
    var menuToggle = header.querySelector('[data-menu-toggle]');

    document.documentElement.removeAttribute('data-mobile-menu-open');

    function explicitMobileNavState() {
      var expanded = menuToggle && menuToggle.getAttribute('aria-expanded');
      var hidden = mobileNav && mobileNav.getAttribute('aria-hidden');
      var stateClasses = mobileNav ? String(mobileNav.className || '') : '';

      if (expanded === 'true' || hidden === 'false' || /(^|\s)(is-open|open|visible|active)(\s|$)/i.test(stateClasses)) {
        return true;
      }

      if (expanded === 'false' || hidden === 'true') return false;

      return null;
    }

    function mobileNavLooksOpen() {
      if (!mobileNav || window.innerWidth > 1024) return false;

      var surface = mobileNav.querySelector('.site-mobile-nav__drawer, .site-mobile-nav__panel, .site-mobile-nav__content') || mobileNav;
      var navStyle = window.getComputedStyle(mobileNav);
      var surfaceStyle = window.getComputedStyle(surface);
      var rect = surface.getBoundingClientRect();
      var hiddenByStyle = navStyle.display === 'none' || navStyle.visibility === 'hidden' || parseFloat(navStyle.opacity || '1') === 0;
      var surfaceHidden = surfaceStyle.display === 'none' || surfaceStyle.visibility === 'hidden' || parseFloat(surfaceStyle.opacity || '1') === 0;
      var outsideViewport = rect.width <= 1 || rect.height <= 1 || rect.right <= 0 || rect.bottom <= 0 || rect.left >= window.innerWidth || rect.top >= window.innerHeight;

      return !hiddenByStyle && !surfaceHidden && !outsideViewport;
    }

    function syncMobileNavState() {
      var explicitState = explicitMobileNavState();
      var isOpen = explicitState === null ? mobileNavLooksOpen() : explicitState;
      header.toggleAttribute('data-tcg-mobile-nav-open', isOpen);
    }

    function syncAfterThemeUpdate() {
      requestAnimationFrame(function () {
        requestAnimationFrame(syncMobileNavState);
      });
    }

    if (menuToggle) {
      menuToggle.addEventListener('click', syncAfterThemeUpdate, { passive: true });
    }

    if (mobileNav) {
      mobileNav.addEventListener('click', syncAfterThemeUpdate, { passive: true });
      mobileNav.addEventListener('transitionend', syncMobileNavState);

      new MutationObserver(syncMobileNavState).observe(mobileNav, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'aria-expanded', 'class', 'style']
      });
    }

    if (menuToggle) {
      new MutationObserver(syncMobileNavState).observe(menuToggle, {
        attributes: true,
        attributeFilter: ['aria-expanded', 'class']
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') syncAfterThemeUpdate();
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 1024) {
        header.removeAttribute('data-tcg-mobile-nav-open');
      } else {
        syncAfterThemeUpdate();
      }
    }, { passive: true });

    syncMobileNavState();
  }());


/* ===== 2/3 no sticky header on phones (was ll-static-header-f09810.js) ===== */

/* ----------------------------------------------------------------------
   No sticky header on phones.

   A sticky header costs the same strip of screen on every scroll, and on a
   phone that strip is a far bigger share of the page than it is on a desktop
   monitor. Below 750px it now scrolls away with the content; iPad and desktop
   keep it.

   Done by removing the attribute rather than only overriding the CSS, and
   done here rather than on DOMContentLoaded, because empire.js is loaded
   async: this inline script runs during parse, so Empire finds no
   `data-site-header-sticky` and never initialises sticky at all. Fighting it
   afterwards would mean undoing whatever spacer or body padding it had
   already added.

   The CSS override below is the belt to this braces. It covers the case this
   cannot: a window resized down after load, where Empire has already
   initialised and will not undo itself.
---------------------------------------------------------------------- */
(function () {
  try {
    var main = document.querySelector('[data-site-header-main]');
    if (!main) return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    /* Remember it so a reload at desktop width is unaffected - this only ever
       changes the live DOM, never the setting. */
    main.setAttribute('data-ll-sticky-off', '1');
    main.removeAttribute('data-site-header-sticky');

    /* Empire is not the only thing that can pin this. Some builds mark the
       section wrapper instead, and the theme's own CSS may carry
       position:sticky on it. Flag the wrappers so the stylesheet above has a
       hook, and strip any sticky data attributes it finds on the way up. */
    var node = main;
    for (var i = 0; i < 4 && node; i++) {
      node = node.parentElement;
      if (!node) break;
      if (node.hasAttribute && node.hasAttribute('data-site-header-sticky')) {
        node.removeAttribute('data-site-header-sticky');
      }
    }
  } catch (e) {}
})();

/* ----------------------------------------------------------------------
   Watchlist badge.

   Reads the shared `ll_watchlist` key and repaints on the same
   `ll:watchlist:change` event every other section fires, so a bell tapped
   on a product page, a hub, a collection or the deals strip updates the
   header immediately without a reload. The storage listener covers a second
   tab, and the sync snippet fires the same event when the account copy
   arrives, so a signed-in shopper landing on a new device sees the real
   number as soon as it syncs rather than a stale zero.

   Deliberately no Liquid-rendered count: for a guest the list exists only in
   their browser, and for a customer the account copy has not arrived at
   render time. Either way Liquid would print the wrong number first.
---------------------------------------------------------------------- */
(function () {
  if (window.__llHeaderWatchBooted) return;
  window.__llHeaderWatchBooted = true;

  var KEY = 'll_watchlist';
  var LEGACY = 'll_preorder_watch';

  function boot() {
    var box = document.querySelector('[data-ll-header-watch]');
    if (!box) return;
    var num = box.querySelector('[data-ll-header-watch-count]');
    var sr = box.querySelector('[data-ll-header-watch-sr]');

    function read() {
      try {
        var raw = localStorage.getItem(KEY);
        if (raw == null) raw = localStorage.getItem(LEGACY);
        var list = raw ? JSON.parse(raw) : [];
        if (Object.prototype.toString.call(list) !== '[object Array]') return 0;
        /* De-duplicate defensively: an older section could have written a
           list with repeats, and a count that disagrees with the page the
           badge links to is worse than no badge. */
        var seen = {}, n = 0;
        for (var i = 0; i < list.length; i++) {
          var h = String(list[i] || '').trim();
          if (!h || seen[h]) continue;
          seen[h] = 1;
          n++;
        }
        return n;
      } catch (e) { return 0; }
    }

    function paint() {
      var n = read();
      box.setAttribute('data-count', String(n));
      box.hidden = n < 1;
      if (num) num.textContent = n > 99 ? '99+' : String(n);
      if (sr) {
        sr.textContent = n === 1
          ? 'Your watchlist, 1 item'
          : 'Your watchlist, ' + n + ' items';
      }
    }

    /* ------------------------------------------------------------------
       Publish the right cluster's real width.

       .site-header-right is absolutely positioned above 769px, so the row
       keeps clear of it with padding rather than layout. That padding has to
       match a width that genuinely varies: "Join free" is wider than a
       returning customer's name, the wording hides at 1180px, and this badge
       appears only once the list has something in it. Measuring beats every
       fixed number we could pick.
    ------------------------------------------------------------------ */
    var right = document.querySelector('.site-header-right');
    var main = document.querySelector('.site-header-main');
    function measure() {
      if (!right || !main) return;
      var w = Math.ceil(right.getBoundingClientRect().width);
      if (w > 0) main.style.setProperty('--ll-right-w', w + 'px');
    }

    function refresh() { paint(); measure(); }

    refresh();
    document.addEventListener('ll:watchlist:change', refresh);
    window.addEventListener('storage', function (e) {
      if (!e || e.key === KEY || e.key === LEGACY) refresh();
    });
    window.addEventListener('resize', measure);
    /* Fonts land after first paint and change the account text width. */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    if (window.ResizeObserver && right) new ResizeObserver(measure).observe(right);
    /* The sync snippet may resolve the account list slightly after load. */
    setTimeout(refresh, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


/* ===== 3/3 desktop nav flyouts (was ll-static-header-e35727.js) ===== */

/* ----------------------------------------------------------------------
   Desktop nav flyouts

   Sizes every open panel to the room it actually has, and places the third
   level in viewport coordinates so the scrolling second level cannot clip
   it. See the matching CSS block for the reasoning.

   The theme keeps ownership of open and close. Each level is a <details>
   that Empire toggles; this only measures and positions what Empire has
   opened, so if the script never runs the nav behaves as it does today.
---------------------------------------------------------------------- */
(function () {
  var header = document.querySelector('[data-site-header]');
  if (!header || header.dataset.tcgNavFlyouts === 'true') return;

  var nav = header.querySelector('.site-navigation');
  if (!nav) return;
  header.dataset.tcgNavFlyouts = 'true';

  var EDGE = 12;   // breathing room against the viewport edges
  var mq = window.matchMedia('(min-width: 1025px)');
  var frame = null;

  function desktop() { return mq.matches; }

  /* Empire's shape is li > details > ul. The panel is never a direct child
     of the item, which is the whole reason a naive lookup finds nothing. */
  function panelOf(item) {
    if (!item || item.tagName !== 'LI') return null;
    var details = item.querySelector(':scope > details');
    var panel = details ? details.querySelector(':scope > ul') : item.querySelector(':scope > ul');
    return panel || null;
  }

  /* The theme already labels the level: navmenu-depth-2, -3, ... */
  function levelOf(panel) {
    var match = /navmenu-depth-(\d+)/.exec(String(panel.className || ''));
    return match ? parseInt(match[1], 10) : 2;
  }

  function openPanels() {
    var out = [];
    nav.querySelectorAll('details[open]').forEach(function (details) {
      var panel = details.querySelector(':scope > ul');
      if (panel) out.push(panel);
    });
    return out;
  }

  /* These panels are box-sizing: content-box, so max-height caps the CONTENT
     box and padding lands on top of it. Measure that overhang rather than
     guessing, or a padded panel overshoots the bottom of the screen. */
  function boxExtra(panel) {
    var cs = getComputedStyle(panel);
    if (cs.boxSizing !== 'content-box') return 0;
    return (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0) +
           (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.borderBottomWidth) || 0);
  }

  /* Size of a panel that is still closed: shown invisibly for one
     measurement, then put back exactly as it was. */
  function measure(panel) {
    if (panel.getClientRects().length) {
      return { w: panel.offsetWidth, h: panel.scrollHeight };
    }
    var prev = panel.style.cssText;
    panel.style.setProperty('display', 'block', 'important');
    panel.style.setProperty('visibility', 'hidden', 'important');
    panel.style.setProperty('opacity', '0', 'important');
    panel.style.setProperty('height', 'auto', 'important');
    panel.style.setProperty('max-height', 'none', 'important');
    var size = { w: panel.offsetWidth, h: panel.scrollHeight };
    panel.style.cssText = prev;
    return size;
  }

  /* ---- scroll affordance ------------------------------------------------ */
  function syncEnd(panel) {
    if (panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 6) panel.setAttribute('data-tcg-end', '');
    else panel.removeAttribute('data-tcg-end');
  }

  function markScroll(panel) {
    if (panel.scrollHeight - panel.clientHeight > 4) panel.setAttribute('data-tcg-scrolls', '');
    else panel.removeAttribute('data-tcg-scrolls');
    syncEnd(panel);
  }

  function bindScroll(panel) {
    if (panel.hasAttribute('data-tcg-sub')) return;
    panel.setAttribute('data-tcg-sub', '');
    panel.addEventListener('scroll', function () {
      syncEnd(panel);
      // A level-3 flyout is anchored to a row inside this panel, so scrolling
      // the panel has to carry it along.
      scheduleRefresh();
    }, { passive: true });
  }

  /* ---- placement -------------------------------------------------------- */

  /* The highest a flyout may reach.

     Level 3 slides up to keep its last row on screen, and used to stop at
     EDGE - 12px from the top of the VIEWPORT. The header is ~246px tall and
     the flyout sits at z-index 1103 above it, so any list tall enough to need
     the slide (Scarlet & Violet, 25 sets) rode straight up over the search
     bar, the logo and the utility links.

     The header is the real ceiling, not the viewport. Measured live rather
     than assumed: it is sticky, so its bottom moves, and once it has scrolled
     away (bottom <= 0) the whole viewport is fair game again. */
  function topBoundary() {
    var limit = EDGE;
    if (header) {
      var hr = header.getBoundingClientRect();
      if (hr.bottom > 0 && hr.top < window.innerHeight) {
        limit = Math.max(limit, hr.bottom + 8);
      }
    }
    return limit;
  }

  function sizeLevel2(panel) {
    var top;
    if (panel.getClientRects().length) {
      top = panel.getBoundingClientRect().top;
    } else {
      var owner = panel.parentElement && panel.parentElement.closest('li');
      top = owner ? owner.getBoundingClientRect().bottom : 0;
    }
    var avail = window.innerHeight - top - EDGE - boxExtra(panel);
    panel.style.setProperty('--tcg-sub-maxh', Math.max(180, Math.round(avail)) + 'px');
    markScroll(panel);
  }

  function placeLevel3(panel) {
    var item = panel.parentElement && panel.parentElement.closest('li');
    if (!item) return;

    var ir = item.getBoundingClientRect();
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var extra = boxExtra(panel);
    /* Room between the header and the bottom edge - not the whole viewport,
       which is what let a tall list grow past the header and then slide into
       it. Level 2 has always measured from its own top for this reason; this
       is the same rule applied one level down. */
    var minTop = topBoundary();
    var avail = vh - minTop - EDGE - extra;
    panel.style.setProperty('--tcg-sub-maxh', Math.max(180, Math.round(avail)) + 'px');

    var size = measure(panel);
    var w = size.w || 240;
    var h = Math.min(size.h + extra, vh - minTop - EDGE);

    // Sideways: out to the right as the theme intends, flipping to the left
    // when there is no room for it there.
    var left = ir.right - 1;
    if (left + w > vw - EDGE) {
      var flipped = ir.left - w + 1;
      left = flipped >= EDGE ? flipped : Math.max(EDGE, vw - EDGE - w);
    }

    // Vertically: level with its row as before, then slid up as far as it
    // takes to keep the last set on screen. This is the part that was missing.
    var top = ir.top - 15;
    if (top + h > vh - EDGE) top = vh - EDGE - h;
    if (top < minTop) top = minTop;

    panel.style.setProperty('--tcg-sub-left', Math.round(left) + 'px');
    panel.style.setProperty('--tcg-sub-top', Math.round(top) + 'px');

    /* `fixed` resolves against the viewport unless an ancestor is transformed.
       The header is sticky today and sticky does not do that - but a theme
       update could, so measure where the panel actually landed and correct by
       the difference rather than trusting it. */
    if (panel.getClientRects().length) {
      var pr = panel.getBoundingClientRect();
      var dx = left - pr.left;
      var dy = top - pr.top;
      if (Math.abs(dx) > 0.5 || Math.abs(dy) > 0.5) {
        panel.style.setProperty('--tcg-sub-left', Math.round(left + dx) + 'px');
        panel.style.setProperty('--tcg-sub-top', Math.round(top + dy) + 'px');
      }
    }
    markScroll(panel);
  }

  function place(panel) {
    if (!panel || !desktop()) return;
    if (levelOf(panel) >= 3) placeLevel3(panel);
    else sizeLevel2(panel);
  }

  function scheduleRefresh() {
    if (frame) return;
    frame = requestAnimationFrame(function () {
      frame = null;
      if (desktop()) openPanels().forEach(place);
    });
  }

  /* ---- wiring ----------------------------------------------------------- */

  /* Pre-place on approach. The details `toggle` event is queued as a task, so
     on its own it can leave one frame where a level-3 panel is still parked
     inside the scrollport that would clip it. pointerover runs first. */
  nav.addEventListener('pointerover', function (e) {
    if (!desktop() || !e.target || !e.target.closest) return;
    var item = e.target.closest('li');
    if (!item || !nav.contains(item)) return;
    var panel = panelOf(item);
    if (!panel || panel.getAttribute('data-tcg-armed') === '1') return;
    panel.setAttribute('data-tcg-armed', '1');
    bindScroll(panel);
    place(panel);
  });

  /* Authoritative: fires whenever the theme opens or closes a level, however
     it was triggered - hover, click, keyboard. Non-bubbling, hence capture. */
  nav.addEventListener('toggle', function (e) {
    var details = e.target;
    if (!details || details.tagName !== 'DETAILS' || !desktop()) return;
    var panel = details.querySelector(':scope > ul');
    if (!panel) return;

    if (!details.open) {
      panel.removeAttribute('data-tcg-armed');
      panel.removeAttribute('data-tcg-scrolls');
      panel.removeAttribute('data-tcg-end');
      panel.scrollTop = 0;
      return;
    }

    bindScroll(panel);
    place(panel);
    // Re-measure once the theme's open animation has run its height.
    requestAnimationFrame(function () { place(panel); });
    setTimeout(function () { place(panel); }, 260);
  }, true);

  /* A fixed panel is pinned to the viewport, so anything that moves its
     anchor has to move it too. */
  window.addEventListener('scroll', scheduleRefresh, { passive: true });
  window.addEventListener('resize', scheduleRefresh);

  /* Escape closes the open levels, innermost first. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = nav.querySelectorAll('details[open]');
    for (var i = open.length - 1; i >= 0; i--) open[i].open = false;
  });
}());

/* ── Predictive search: two ways Empire's own binding drops a query ─────────
   Empire runs its live search off key releases alone, debounced:

     this.$input.on('keyup.live-search', debounce(this._search, 250))

   and _search opens with a guard that abandons the whole search when the event
   is a key it considers non-textual:

     const invalidKeyStrokes = ['Alt','ArrowRight','ArrowLeft','ArrowUp',
       'ArrowDown','Capslock','Control','Escape','Meta','Shift','Tab','Enter'];
     if (event.key && invalidKeyStrokes.indexOf(event.key) !== -1) return;

   Debouncing means only the LAST release in a 250ms window ever reaches that
   guard, and the guard throws the query away rather than searching what is in
   the field. So:

   1. TYPING A CAPITAL. Type "Mew" and release Shift a beat after the M, or
      type anything in caps, and the final release in the window is Shift. The
      search is abandoned and the shopper sees nothing, having typed a perfectly
      good query. Measured: last release "w" opens the flydown at 672px, last
      release "Shift" leaves it at 1px.

   2. TEXT THAT ARRIVES WITHOUT A KEY. Pasting fires input and never keyup, so
      the search never runs at all. On a card shop people paste card names
      constantly. Autofill, speech input and IME commits land the same way.

   Both are answered by re-dispatching a release Empire will accept. It is the
   event the theme already listens for and already debounces, so this stays out
   of its internals and cannot double up the request.

   ARROWS, TAB, ENTER AND ESCAPE ARE DELIBERATELY NOT BRIDGED. Those are in
   Empire's list because they drive the flydown rather than the query: arrows
   walk the results, Enter submits, Escape dismisses, Tab leaves. Re-searching
   on those would rebuild the list underneath someone using it.            */
(function () {
  'use strict';

  var SEL = '[data-live-search-input]';

  /* Modifiers only. Releasing one should never discard a pending query. */
  var MODIFIERS = ['Shift', 'Control', 'Alt', 'Meta', 'CapsLock', 'Capslock'];

  function nudge(el) {
    if (!el || !el.value) return;
    try {
      el.dispatchEvent(new KeyboardEvent('keyup', {
        bubbles: true,
        key: 'Unidentified'
      }));
    } catch (err) {
      /* No KeyboardEvent constructor: the theme keeps the behaviour it had,
         which this improves on rather than depends on. */
    }
  }

  function isField(el) {
    return el && typeof el.matches === 'function' && el.matches(SEL);
  }

  /* A modifier release landing last in the window would abandon the query.
     'Unidentified' is not in Empire's list, so the re-dispatch searches and
     cannot recurse. */
  document.addEventListener('keyup', function (e) {
    if (!isField(e.target)) return;
    if (MODIFIERS.indexOf(e.key) === -1) return;
    nudge(e.target);
  });

  /* Text that arrived without a key release at all. */
  document.addEventListener('input', function (e) {
    if (!isField(e.target)) return;
    var type = e.inputType || '';
    if (type === 'insertText' || type.indexOf('delete') === 0) return;
    nudge(e.target);
  });
}());
